export default __webpack_public_path__ + "static/media/ribeya.d6e1524a.jpg";